<template>
  <v-container
    grid-list-md
  >
    <AuditsCondition
      :cond="cond"
      :categories="categories"
      :users="users"
    />
    <v-layout row>
      <v-flex
        md8
      >
        <MaterialCard
          color="green"
          full-width
        >
          <v-data-table
            :headers="headers"
            :items="audits"
            :disable-initial-sort="true"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td @click="onAuditSelected(item)">
                {{ item.time | format }}
              </td>
              <td @click="onAuditSelected(item)">
                {{ item.userName }}
              </td>
              <td @click="onAuditSelected(item)">
                {{ item.categoryName }}
              </td>
              <td @click="onAuditSelected(item)">
                {{ item.message }}
              </td>
            </template>
          </v-data-table>
        </MaterialCard>
      </v-flex>
      <v-flex
        md4
      >
        <AuditsDetail
          v-if="selected != null"
          :audit="selected"
          :users="users"
          :categories="categories"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { AuditsCondition, AuditsDetail } from './components'
import * as moment from 'moment'

export default {
  components: {
    AuditsCondition,
    AuditsDetail
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const response = await search(to.query)
      next(vm => {
        vm.init(response)
      })
    } catch (e) {
      next(e)
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      const response = await search(to.query)
      this.init(response)
      next()
    } catch (e) {
      next(e)
    }
  },
  filters: {
    format (time) {
      return moment.unix(time).utcOffset('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss')
    }
  },
  data: () => ({
    cond: {
      from: moment().add(-8, 'days').utc().unix(),
      to: moment().utc().unix(),
      userId: -1,
      categoryId: -1
    },
    headers: [
      { sortable: true, text: '時刻', value: 'time' },
      { sortable: true, text: 'ユーザー', value: 'userId' },
      { sortable: true, text: 'カテゴリー', value: 'categoryId' },
      { sortable: false, text: '内容', value: 'message' }
    ],
    allAudits: [],
    categories: [],
    users: [],
    selected: null
  }),
  computed: {
    audits () {
      return this.allAudits.filter(a => {
        if (this.cond.from !== -1 && a.time < this.cond.from) {
          return false
        }
        if (this.cond.to !== -1 && a.time > this.cond.to) {
          return false
        }
        if (this.cond.userId !== -1 && a.userId !== this.cond.userId) {
          return false
        }
        if (this.cond.categoryId !== -1 && a.categoryId !== this.cond.categoryId) {
          return false
        }

        return true
      })
    }
  },
  methods: {
    init (value) {
      const { audits, categories, users } = value
      this.allAudits = audits.map(a => {
        const audit = Object.assign({}, a)
        audit.userName = users.find(u => a.userId === u.id).name
        audit.categoryName = categories.find(c => a.categoryId === c.id).name
        return audit
      })
      this.categories = categories
      this.users = users
    },
    onAuditSelected (item) {
      this.selected = item
    }
  }
}

export const search = async (query) => {
  const response = {
    audits: [
      // eslint-disable-next-line
      { id: 1, userId: 1, time: 1589430962, categoryId: 1, message: 'ログインに成功しました。', detail: 'ログインに成功しました。' },
      { id: 2, userId: 1, time: 1589330962, categoryId: 1, message: 'ログインに失敗しました。', detail: 'ログインに失敗しました。' },
      { id: 3, userId: 2, time: 1589230962, categoryId: 2, message: '顧客を修正しました。', detail: '顧客 [ABC] の名前を [DEF] に変更しました。' },
      { id: 4, userId: 2, time: 1589130962, categoryId: 2, message: '顧客を登録しました。', detail: '顧客 [ABC] を登録しました。' },
      { id: 5, userId: 3, time: 1589030962, categoryId: 2, message: '顧客を削除しました。', detail: '顧客 [ABC] を削除しました。' },
      { id: 6, userId: 4, time: 1588930962, categoryId: 3, message: 'センサーを破棄しました。', detail: 'センサー [ABCDEF] を破棄しました。' },
      { id: 7, userId: 5, time: 1588830962, categoryId: 3, message: 'センサーを登録しました。', detail: 'センサー [123456] を登録しました。' }
    ],
    categories: [
      { id: 1, name: '認証' },
      { id: 2, name: '顧客' },
      { id: 3, name: 'センサー' }
    ],
    users: [
      { id: 1, name: 'ユーザー1' },
      { id: 2, name: 'ユーザー2' },
      { id: 3, name: 'ユーザー3' },
      { id: 4, name: 'ユーザー4' },
      { id: 5, name: 'ユーザー5' }
    ]
  }

  return response
}
</script>
